import { track } from '@fff-web/fff-analytics';
import type { EPayContext } from '../../interfaces';
import { ACQUISITION_COMPLETED, PURCHASE_PRODUCT_TYPE } from './constants';
import { getUUID } from './uuid';

const getAcquisitionType = (
  payContext: EPayContext,
  hasNonMember?: boolean,
  hasIntro?: boolean,
  hasRefill?: boolean,
) => {
  if (payContext === 'gtb') {
    return PURCHASE_PRODUCT_TYPE.gtb;
  }
  if (!hasNonMember && hasRefill && !hasIntro) {
    return PURCHASE_PRODUCT_TYPE.publicSub;
  }
  if (hasIntro && !hasRefill) {
    return PURCHASE_PRODUCT_TYPE.introProduct;
  }
  if (hasIntro && hasRefill) {
    return PURCHASE_PRODUCT_TYPE.publicSubMember;
  }
  if (hasNonMember && !hasIntro && hasRefill) {
    return PURCHASE_PRODUCT_TYPE.publicSubNonMember;
  }
  if (hasNonMember && !hasIntro && !hasRefill) {
    return PURCHASE_PRODUCT_TYPE.nonMember;
  }
  return '';
};

const trackAquisitionCompleted = (
  sku: string | undefined,
  statusMessage: string,
  paymentType: string,
  payContext: EPayContext,
  productType: string,
) => {
  track({
    trackName: ACQUISITION_COMPLETED,
    properties: {
      type: productType,
      cta_name: 'ORDER THE BOX',
      sku: sku || null,
      status: statusMessage,
      payment_type: paymentType,
    },
    options: {
      Optimizely: {
        userId: getUUID(payContext),
      },
    },
  });
};

interface TrackFieldInteractionEventProps {
  formType: string;
  fieldName: string;
  section: string;
  action: string;
}

const trackFieldInteractionEvent = ({
  formType,
  fieldName,
  section,
  action,
}: TrackFieldInteractionEventProps) => {
  track({
    trackName: 'Form Field Interaction',
    properties: {
      fieldName,
      section, // account | shipping | payment
      action, // focus, blur, click, change, submit
      formType: formType,
      skipTitleCase: ['action', 'fieldName', 'formType', 'section'],
    },
  });
};

export { trackAquisitionCompleted, trackFieldInteractionEvent, getAcquisitionType };
